import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';

// Shown when deleting an item from the dashboard fails
const UploadFailure = () => {
    const navigate = useNavigate();

    return (
        <div className='flex flex-col px-8 pb-8 space-y-4 text-white'>
            <div className='text-lg'>The item couldn't be deleted</div>
            <div className='text-zinc-400'>Nothing was changed. Please try again, or log in again if this keeps happening.</div>
            <Button onClick={() => navigate('/juli+dashboard/delete')}>Back to delete</Button>
        </div>
    )
}

export default UploadFailure
